module.exports = __webpack_public_path__ + "img/cover.b8636685.png";